import React, { useState, useContext } from "react";
import { Card, Modal } from "antd";
import { FormattedMessage } from "react-intl";
import { SaveOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";

import TimeCodeSectionFormItem from "./TimeCodeSectionFormItem";

import SectionSwitch from "../../../Fields/SectionSwitch";

import { FormV5Context } from "../../NodeChannelFormV5";

import useNodeChannelConfig from "../../../../hooks/useNodeChannelConfig";

import EnginePlayoutElement from "../../../EnginePlayoutElement";

export default function TimeCodeSection({ disabled, handleFinish }) {
  const [open, setOpen] = useState(false);
  const form = useContext(FormV5Context);

  const { channelConfig, timecode } = useNodeChannelConfig();

  const { resetFields, getFieldValue, validateFields } = form;

  const handleSaveTimeCode = async () => {
    await validateFields();
    const formData = getFieldValue("timecode");

    handleFinish({ ...channelConfig, timecode: formData });
    setOpen(false);
  };

  return (
    <Card
      title={
        <>
          <FormattedMessage id="TimeCodeSection.timecode" defaultMessage="Time code" />{" "}
          <SectionSwitch
            prefix={["timecode", "enabled"]}
            disabled={disabled}
            handleFinish={handleFinish}
            handleOpen={() => setOpen(true)}
          />
        </>
      }
    >
      {timecode?.enabled && (
        <EnginePlayoutElement
          label={<FormattedMessage id="TimeCodeSection.timecode" defaultMessage="Time code" />}
          handleClick={() => setOpen(true)}
          data={timecode}
        />
      )}
      <Modal
        title={<FormattedMessage id="TimeCodeSection.timecode" defaultMessage="Time code" />}
        centered
        destroyOnClose
        open={open}
        onCancel={() => {
          resetFields();
          setOpen(false);
        }}
        onOk={handleSaveTimeCode}
        width={1280}
        footer={disabled ? null : undefined}
        okText={
          <span>
            <FormattedMessage id="general.save" defaultMessage="Save" />
          </span>
        }
        okButtonProps={{ icon: <SaveOutlined /> }}
      >
        <TimeCodeSectionFormItem prefix={["timecode"]} disabled={disabled} />
      </Modal>
    </Card>
  );
}

TimeCodeSection.propTypes = {
  disabled: PropTypes.bool.isRequired,
  handleFinish: PropTypes.func.isRequired,
};
